// This file contains the detailed project review data parsed from your form.
export const projects = [
    {
      id: 3001,
      studentName: 'Ayush',
      rollNumber: '22B0051',
      anonymous: false,
      projectType: 'BTP',
      topic: 'Deep learning',
      professor: 'Prabhu Ramachandran',
      department: 'Aerospace',
      description: 'Use of RBF networks which are much more interpretable in euclid space compared to CNNs for image processing tasks',
      profExperience: 'Great, we used to have weekly meets and he always gave his inputs to navigate the direction of research. Extent of involvement of a prof is slighly on the lower side generally but we used to meet him weekly and not his TAs or RAs',
      learning: 'We did a lot of literature reviews, because we are making something very foundational in deepL, I got the chance to spend enough time understanding how deepL was initiated and I replicate the experiments for our network. I personally think before my BTP my entire experience with ML or Computer vision was way too theoretical, my work with prof. Prabhu gave me chance to make things more application based, we did hundreds of experiments with a lot of tweaking and iterations and brain storming over why things are not going the way we expect. It gave me a taste of how actually research is done unlike just going through what works and what not in course curriculums',
      startDate: '16/08/2024',
      duration: '~2 semester (around 2 semester)',
      onCampusVacation: 'No',
      timePerWeek: '4-5 hours',
      labsUsed: 'No',
      labExperience: 'We were not too much involved with the labs, it was mostly our personal laptops',
      labCooperation: 'N/A',
      credits: 12,
      recommend: 'Yes',
      impact: 'Not yet atleast',
      reportLink: null,
      rating: 10,
    },
    {
      id: 3002,
      studentName: 'Swetansh Gautam',
      rollNumber: '22b0032',
      anonymous: true,
      projectType: 'BTP',
      topic: 'Controls, Multi agent manoeuvring for agents using optimal control',
      professor: 'Debasish Chatterjee',
      department: 'SysCon',
      description: 'Multi agent manoeuvre for numerous agents from initial to final position using Optimal transport having colision avoidance',
      profExperience: 'Great',
      learning: 'Basics Optimal Transport, Approximations, DNN, an idea of Stochastic control, maybe then can help in my research further',
      startDate: '01/04/2025',
      duration: '3-10 weeks(less than half sem)',
      onCampusVacation: 'No',
      timePerWeek: '3-4',
      labsUsed: 'No',
      labExperience: 'No',
      labCooperation: 'Very',
      credits: 6,
      recommend: 'Yeah no doubt',
      impact: 'not right now but chances are by the end of this semester',
      reportLink: null,
      rating: 8,
    },
    {
      id: 3003,
      studentName: 'Tarshit Sehgal',
      rollNumber: '22B0077',
      anonymous: false,
      projectType: 'BTP',
      topic: 'Structures, Bio inspired wing morphing for gust alleviation',
      professor: 'Prof. Abhijit Gogulapati',
      department: 'Aerospace',
      description: 'Bio inspired wing morphing for gust alleviation',
      profExperience: "My experience till now has been very good. The professor has a decent amount of involvment in the project. He doesn't has direct problems to give you but if you propose the project yourself, he can help you to refine the statement. In general He is a good prof to work with. Deadlines are chill, and weekly meets. In my case, my project topic has been his topic of interest in past, so he seems genuinely interested in the project which makes thing even better. He is one of the profs who are really passionate about what they do, one can easily sense it on having a conversation with him.",
      learning: 'I got to apply what I learned in the courses, that way you learn way more than when you studied for exams. Apart from that, I got better hold of softwares like MATLAB and Ansys.',
      startDate: '15/01/2025',
      duration: '~2 semester (around 2 semester)',
      onCampusVacation: 'No',
      timePerWeek: '12-15 hrs',
      labsUsed: 'No',
      labExperience: 'N/A',
      labCooperation: 'I once needed help of some PhD student who was part of the same lab, he was glad to help me',
      credits: 18, // 6 + 12 (ongoing)
      recommend: 'I would strongly recommend working under him if your interest aligns well with what he does. Even though he is a structures prof officially, he is a multidisciplinary person, others areas being aerodynamics, optimization, ML and a little background in controls',
      impact: "The project is still ongoing so I can't say much, but this project is mostly about exploring a different way of doing wing morphing with a goal to alleviate gust effects, we don't know how this will pan out eventually, that what were are trying to see, if it turns out well and the things assumed in the project can be practically made, then it may have an impact in MAV industry sometime later, as such direct impact, no.",
      reportLink: null,
      rating: 9,
    },
    {
      id: 3004,
      studentName: 'Kunj',
      rollNumber: '22b0019',
      anonymous: false,
      projectType: 'Other Projects', // Mapped from "R&D Project (Credited)"
      topic: 'Data Analytics',
      professor: 'Saket Choudhary',
      department: 'KCDH',
      description: 'Disease Burden Estimation in India. My job was to extract, analyze and draw conclusions from the yearly medical data posted by Indian govt. It involved using google senitnal data to correlate environmental factors with numbers of death. Plotting disease heatmaps and identifying stat-wise, gender-wise and age-wise trends.',
      profExperience: 'Exhilarating',
      learning: 'Statistics and data analytics',
      startDate: '08/08/2024',
      duration: '~2 semester (around 2 semester)',
      onCampusVacation: 'It was during academic semester',
      timePerWeek: '3 hrs',
      labsUsed: 'No',
      labExperience: 'no',
      labCooperation: 'Very',
      credits: 12, // 6+6
      recommend: 'Yes',
      impact: 'Not industry level',
      reportLink: 'https://drive.google.com/open?id=1g-MmmqATTyMLZBwq-1I4ol-q3hjGF67N',
      rating: 10,
    },
    {
      id: 3005,
      studentName: 'Ananya Chavadhal',
      rollNumber: '22B0045',
      anonymous: false,
      projectType: 'Other Projects', // Mapped from "R&D Project (Credited)"
      topic: 'Health informatics',
      professor: 'Saket Choudhary',
      department: 'KCDH',
      description: 'Machine Learning to identify obstructive sleep apnea',
      profExperience: 'Experience was great. Professor was very knowledgeable and took weekly meets to discuss findings and gave advice on next steps. He is also very approachable.',
      learning: 'I learnt how to work with big data and make it useful to real world applications such as disease identification and prevention. I also learnt patience and determination, thanks to the nature of research.',
      startDate: '19/08/2024',
      duration: '~3 semesters',
      onCampusVacation: 'No',
      timePerWeek: '6-8 hours',
      labsUsed: 'No',
      labExperience: 'N/A',
      labCooperation: 'Quite cooperative',
      credits: 6,
      recommend: 'Yes, prof is great to work with.',
      impact: 'Yes, the tool is being built in collaboration with AIIMS Delhi as an enhancement of an existing market product',
      reportLink: null,
      rating: 10,
    },
    {
      id: 3006,
      studentName: 'Devesh Mittal',
      rollNumber: '22b0070',
      anonymous: false,
      projectType: 'BTP',
      topic: 'Aerodynamics',
      professor: 'Janani Muralidharan',
      department: 'Mechanical',
      description: 'Simulation of turbine blade',
      profExperience: 'Good',
      learning: 'Helped me in getting in intenrship',
      startDate: '01/01/2025',
      duration: '~2 semester (around 2 semester)',
      onCampusVacation: 'No',
      timePerWeek: '6',
      labsUsed: 'No',
      labExperience: 'N/A',
      labCooperation: 'Very',
      credits: 18,
      recommend: 'No',
      impact: 'N/A', // Not specified
      reportLink: null,
      rating: 10,
    },
    {
      id: 3007,
      studentName: 'Muriki Sree Baruni',
      rollNumber: '22B0059',
      anonymous: true,
      projectType: 'BTP',
      topic: 'Propulsion',
      professor: 'Prof. A. M. Pradeep',
      department: 'Aerospace Engineering',
      description: 'Surface roughness studies on tandem blade compressor stage',
      profExperience: 'It has been great so far.My tasks are still far from the core topic though.',
      learning: 'However, the intended learning goals are: turbomachinery design challenges in practice, instabilities, grasp of propulsion, ...',
      startDate: '02/06/2025',
      duration: '~2 semester (around 2 semester)',
      onCampusVacation: 'No',
      timePerWeek: '~6-8 hours',
      labsUsed: 'No',
      labExperience: 'N/A',
      labCooperation: 'PhDs have been extremely supportive all throughout.',
      credits: 18,
      recommend: 'Yep',
      impact: 'Very minimal.',
      reportLink: null,
      rating: 8,
    },
    {
      id: 3008,
      studentName: 'Om Soni',
      rollNumber: '22b0025',
      anonymous: false,
      projectType: 'SLP',
      topic: 'Aircraft Design',
      professor: 'Dhwanil Shukla, Chandra Sekher Y., T. Chandra Sekhar',
      department: 'Aerospace Engineering',
      description: 'The topic is "Designing the digital twin of an eVTOL Air Taxi, aimed for improving inter-city urban mobility solutions". We are making an electric propulsion based VTOL Air Taxi that can carry up to four passengers to a max range of 150km. It\'s a 6 semester long project that is running as part of the \'Aerospace Design Project\'. It began during the third semester and is essentially two SLPs combined (one during the 5th sem and another during the 8th sem).',
      profExperience: 'It was great, the professors are really supportive. We had frequent meets during each semester with them to discuss the progress and the problems encountered.',
      learning: 'General principles and the application of Aircraft design process. Helped me in understanding the individual sub-systems in detail, the theory involved in it and also the problems encountered during the practical application of the said theory.',
      startDate: '09/08/2023',
      duration: '6 Semesters',
      onCampusVacation: 'No',
      timePerWeek: 'We have a meet every week to work on our project that usually stretches 4 hours.',
      labsUsed: 'No',
      labExperience: 'NA',
      labCooperation: 'Very cooperative.',
      credits: 12, // 12 in total
      recommend: 'I would recommend this project to a student. The professors are really supportive and it is overall a very good learning experience.',
      impact: 'Kind of, eVTOL Air Taxi\'s are very popular right now in the aerospace industry and we have researched a lot on the actual feasibility of some vehicles that are being advertised currently given the current TRL of various domains. Based on that we have even figured out some big limits on how scalable such vehicles actually are. So yes overall the work will make an impact in the relevant industry.',
      reportLink: null,
      rating: 9,
    },
    {
      id: 3009,
      studentName: 'Jugal Shah',
      rollNumber: '22B0043',
      anonymous: false,
      projectType: 'SLP',
      topic: 'Aerodynamics, Controls',
      professor: 'Prof. Dhwanil Shukla',
      department: 'Aerospace Engineering',
      description: 'We had to fabricate an e-VTOL from scratch with the aim to make it fly at an altitude of around 100 m and a speed of around 15 m/s based on the RGB camera used for the purpose of ground mapping',
      profExperience: 'The professor is very dedicated and co-operative with all of his SLP/BTP students, he conducts weekly meetings with them to discuss their individual progress and also takes the doubts of each student which he/she might be facing in the project. In this manner one can maintain a thorough progress and work for his/her project throughout the semester.',
      learning: 'Being an aerospace student, I was curious on how are drones/aerial vehicles designed and manufactured, this project taught me both the technical as well as fabrication knowledge on how these vehicles are developed, which is essential for me being an engineer since it enabled me to apply my knowledge on aerodynamics, CAD and simulations on a real project. Moreover, I also got to carry forward the manufacturing tasks and techniques by myself which enhanced my hands-on skills and experience which is quite required for getting into the industry sector.',
      startDate: '20/12/2023',
      duration: '~2 semester (around 2 semester)',
      onCampusVacation: 'No',
      timePerWeek: 'Around 5 hours per week (last manufacturing phase of around 3 to 4 weeks demanded quite longer durations of ~12 hours a week)',
      labsUsed: 'Yes',
      labExperience: 'Cardiovascular (drone) lab in aero annex building',
      labCooperation: 'The lab people assisted me to their best and without those people I could not have even proceeded with this project, their help to me in designing, procuring materials and manufacturing was immensely appreciable',
      credits: 12, // 6 credits per semester
      recommend: 'Yes, I would surely recommend any student to pursue a project under this professor, he is quite open about any of the topics which you might find interesting to work upon',
      impact: 'Yes',
      reportLink: null,
      rating: 9,
    },
    {
      id: 3010,
      studentName: 'Sanskar Maddi',
      rollNumber: '190010041',
      anonymous: false,
      projectType: 'DDP',
      topic: 'Aerodynamics',
      professor: 'Vineeth Nair and Viren Menezes',
      department: 'Aerospace Engineering',
      description: 'DESIGN, DEVELOPMENT AND PERFORMANCE EVALUATION OF A SUPERSONIC INDRAFT TUBE WIND TUNNEL. The objective of this thesis is to design and construct a supersonic indraft tube wind tunnel (SWT) utilizing an indraft configuration and a vacuum chamber for precise pressure control. This study incorporates computational fluid dynamics (CFD) into the design process. Key considerations include establishing an impeccable connection with vacuum chamber flanges, sustaining supersonic flow for designated test durations, and adhering to budget constraints.',
      profExperience: 'Very good. Helped me gain expertise in experimentation and supersonic flow diagnostics',
      learning: 'Experimentation, instrumentation, assembly, flow diagnostics. Provided me with a strong background to attract experimental supersonic research opportunities',
      startDate: '01/01/2023',
      duration: '20 months',
      onCampusVacation: 'Yes',
      timePerWeek: '20',
      labsUsed: 'Yes',
      labExperience: 'Shock Tunnel Laboratory & Acoustics and Flow Diagnostics Laboratory',
      labCooperation: 'Very helpful, especially for equipment procurement, reimbursements, lab safety and purchases',
      credits: 84, // 72+12
      recommend: 'If interested in experimental high-speed flows, yes.',
      impact: 'Yes',
      reportLink: 'https://drive.google.com/open?id=1mH5k468NuL_n-hqAFsYc8t4qKYJm3BBz',
      rating: 10,
    },
    {
      id: 3011,
      studentName: 'Vighnesh JR',
      rollNumber: '210010073',
      anonymous: true,
      projectType: 'DDP',
      topic: 'Aerodynamics, Propulsion',
      professor: 'Vineeth Nair',
      department: 'Aerospace',
      description: 'Study of propagation of disturbances past premixed flame',
      profExperience: 'Good, very supportive',
      learning: 'Level set methods, transfer functions, its a canonical problem so good for theoretical research.',
      startDate: '24/09/2025',
      duration: '10-20 weeks (more than half sem)',
      onCampusVacation: 'Yes',
      timePerWeek: '3 hours',
      labsUsed: 'No',
      labExperience: 'Nope',
      labCooperation: 'Very helpful but I haven’t asked for much assistance',
      credits: 72, // 36 + 36
      recommend: 'Yes if they are interested in academic style resear h',
      impact: 'Nope',
      reportLink: null,
      rating: 8,
    },
    {
      id: 3012,
      studentName: 'Priyanshu kumar',
      rollNumber: '22b0060',
      anonymous: false,
      projectType: 'SLP',
      topic: 'Aerodynamics, Propulsion',
      professor: 'Prof. Asim tewari',
      department: 'Mechanical dept.',
      description: 'It was about modelling a gas turbine engine cycle while incorporating aerodynamics of Compressor and Turbine. And its future aspects will be towards making an Digital twin of gas turbine',
      profExperience: 'Great, but the one thing i would point out is Prof. Asim had a larger direct focus on the thermodynamics and AI,ML part...but for the aerodynamics and in depth propulsion aspects I had to contact others.',
      learning: 'I learnt about how actual modelling of a complete engine is done...also how the throttling and other conditions changes the thrust and outputs and the biggest of all was the coupling of various parts which was an restricted knowledge as per the courses...also got me storng in using python for system modelling.',
      startDate: '01/02/2025',
      duration: '10-20 weeks (more than half sem)',
      onCampusVacation: 'No',
      timePerWeek: '6 hours per week including all literature review.',
      labsUsed: 'No',
      labExperience: 'NCAIR', // This seems to be the lab, but he said "No" to using labs
      labCooperation: 'Good',
      credits: 6,
      recommend: 'I would recommend to work totally under prof. Asim as the projects are the live projects and are more dominant towards the integration of other domains apart from only Aerospace subjects',
      impact: 'Oh! Thts tough to tell...the project is still on going and It is targeted to be make impact on industry level...so yes, I\'ll try it makes an impact',
      reportLink: null,
      rating: 9,
    },
    {
      id: 3013,
      studentName: 'Hitaishi Modi',
      rollNumber: '210040096',
      anonymous: false,
      projectType: 'BTP', // SLP and BTP(continuation) -> Mapped to BTP
      topic: 'Propulsion',
      professor: 'Prof. Krishnendu Sinha',
      department: 'Aerospace Engineering',
      description: "Bachelor's Thesis: Starting Analysis of Curved Compression Ramp Scramjet Intake with Cowl Deflection. Performed Numerical Analysis (MATLAB based, 2D inviscid) to optimize design of CCR intake with a deflected cowl showing Self-starting characteristics, improved performance parameter such as pressure losses and compression ratios, and better operability, meaning higher margins from unstart of engine. Second half of the project involved study of starting characteristics of High-Enthalpy Flows, which is generally the case in real flights. It involved writing a solver for calorically IMPERFECT gas. Later, I focused on validating this findings with CFD results (steady + transient simulations).",
      profExperience: "Working with Professor Sinha is a great experience, but it's a specific style you need to get used to. Don't expect him to hand you a ready-made project topic or tasks. Instead, you'll need to dive deep into the existing research yourself to find a gap that no one has filled yet. The weekly group meetings are where everything comes together. All the PhD, MTech, and BTech students are there. It’s an awesome chance to see what everyone else is working on, present your own progress, and get hit with critical questions and great suggestions from the whole group and professor. Here you also decide plan of action for the coming week. The process is really iterative. You start with lots of papers, then you begin running simulations. Bit by bit, week by week, you build on what you've learned. Slowly, a clear and solid research project just... shapes itself out of the foundational work.",
      learning: "We are all fascinated to CFD, and mostly to the cool looking contours, but don't underestimate the power of simpler numerical analysis. It's not about replacing CFD, but about being smarter. By using numerical models to understand the core physics first, you can see the big picture and save immense time and computing costs, making your CFD work far more focused and effective. So, overall it gave me a new perspective towards research.",
      startDate: '01/05/2024',
      duration: '~ 4 semester (SLP + 1 sem non credited + BTP 1 and BTP 2)',
      onCampusVacation: 'No',
      timePerWeek: 'During the semester, I dedicated an average of 10-15 hours per week. The workload is mostly non-uniform. Weeks focused on running multiple simulation runs required less hands-on time, while times of code debugging or mesh/case setup demanded a lot more effort than average.',
      labsUsed: 'No',
      labExperience: 'NA',
      labCooperation: 'NA',
      credits: 24,
      recommend: 'If your passion lies in computational high-speed flows, SBLI, or Scramjet intake analysis, look no further than Professor Krishnendu Sinha.',
      impact: 'While my work was academic, it\'s exciting to see its relevance to the industry. Several Indian startups are now actively working to turn scramjet theory into reality.',
      reportLink: null,
      rating: 9,
    },
  ];
  